import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Container,
  Typography,
  Paper,
  Button,
  Box,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import Layout from '../components/Layout';
import { safeSameOriginReturn } from '../utils/onboardingHandoff';

const SubscriptionCancel = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const returnPath = safeSameOriginReturn(params.get('return')) || '/dashboard';

  return (
    <Layout>
      <Container maxWidth="sm" sx={{ display: 'flex', alignItems: 'center', minHeight: '60vh' }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            textAlign: 'center',
            width: '100%',
            borderRadius: '24px',
            border: 1,
            borderColor: 'divider',
            bgcolor: 'background.paper'
          }}
        >
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              mx: 'auto',
              mb: 2,
              display: 'grid',
              placeItems: 'center',
              bgcolor: 'warning.light'
            }}
          >
            <WarningIcon sx={{ fontSize: 40, color: 'warning.main' }} />
          </Box>
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
            Subscription Not Completed
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            Your subscription wasn’t completed. No charges have been made to your account.
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate(returnPath)}
            >
              Return to where I was
            </Button>
            <Button
              variant="text"
              onClick={() => {
                try {
                  window.dispatchEvent(new CustomEvent('subscription:upgrade', { detail: { force: true } }));
                } catch (_) {}
              }}
              sx={{ textTransform: 'none' }}
            >
              Try again
            </Button>
          </Box>
        </Paper>
      </Container>
    </Layout>
  );
};

export default SubscriptionCancel; 